import { useContext, useState } from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import { ALL_ANIMATED_MIME_TYPES, VIDEO_MIME_TYPES } from '../../constants'
import { CreationToolsContext } from '../../manager'
import CreationToolOutputType from '../../types/output-type'
import CreationToolStep from '../../types/steps'
import CreationToolWelcomeButton from '../../types/welcome-button'
import { ColumnBlock, ContainerBlock, SplitBlock } from '../blocks'
import Breadcrumbs from '../breadcrumbs'
import Navigation from '../navigation'
import { Text, Title } from '../typography'
import CreationToolsWelcomeFileButton from '../welcome/buttons/button/file'
import AddMoreButton from './add-more-button'
import Buttons from './buttons'
import Editor from './editor'
import Fields from './fields'
import List from './list'
import Preview from './preview'
import CreationToolsUploadManager from './manager'
import Terms from './terms'

const STEP = CreationToolStep.Upload

type Props = {
    submitUrl: string
    apiKey?: string
}

const CreationToolsUpload = ({ submitUrl, apiKey }: Props) => {
    const { sources, stepFrames, outputType } = useContext(CreationToolsContext)
    const isBulk = sources.length > 1
    const [isProcessing, setIsProcessing] = useState<boolean>(!stepFrames.length && isBulk)
    const description = CreationToolStep.description(STEP)
    // TODO is there a better way to do set this?
    const addMoreMimeTypes = outputType === CreationToolOutputType.Video ? VIDEO_MIME_TYPES : ALL_ANIMATED_MIME_TYPES

    return (
        <CreationToolsUploadManager submitUrl={submitUrl} apiKey={apiKey}>
            <ContainerBlock>
                <SplitBlock style={isProcessing ? { opacity: 0, pointerEvents: 'none', maxHeight: '80vh' } : {}}>
                    <ColumnBlock>
                        <div>
                            <Navigation>
                                <CreationToolsWelcomeFileButton
                                    button={CreationToolWelcomeButton.UploadAddMore}
                                    mimeTypesOverride={addMoreMimeTypes}
                                >
                                    <AddMoreButton isProcessing={isProcessing} />
                                </CreationToolsWelcomeFileButton>
                            </Navigation>
                            {/* 
                                If source is not animated, and has step frames, go to preview. If not, goes to List.
                                The big difference between both, is that <List /> allow to use UGE, Preview, not, and we should be able to use UGE for animated sources.
                             */}
                            {!sources[0].isAnimated && stepFrames.length > 0 ? (
                                <Preview />
                            ) : (
                                <List setIsProcessing={setIsProcessing} />
                            )}
                        </div>
                        <Breadcrumbs />
                    </ColumnBlock>
                    <ColumnBlock>
                        <div>
                            <Title>{CreationToolStep.title(STEP)}</Title>
                            {description && <Text>{description}</Text>}
                            <Fields />
                            <Terms />
                        </div>
                        <Buttons />
                    </ColumnBlock>
                </SplitBlock>
                {isProcessing && <DotsLoader isAbsolute />}
            </ContainerBlock>
            <Editor />
        </CreationToolsUploadManager>
    )
}

export default CreationToolsUpload
